export default __webpack_public_path__ + "static/background-gray-edea2b3eac72b3e01c59eda024faabc3.png";